import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  FORM_BP,
  FORM_MG,
  FORM_MG_NO_SHOP,
  INSURANCE,
  PENDIENTES_DE_DATOS,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';

@Component({
  selector: 'scf-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
})
export class InsuranceComponent implements OnInit {
  public insuranceForm: FormGroup;
  insuranceValues: CommonDataDTO[];
  @Input() public mode: string = 'new';
  @Input() public insurance: any = null;
  @Input() state: CommonDataDTO;
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore
  ) {
    this.insuranceValues = this.combosStore.insuranceValues;
  }

  ngOnInit() {
    this.createForm();
    this.insuranceForm.statusChanges.subscribe(() => {
      if (this.insuranceForm.valid) {
        this.changeContinueStatus.emit({ form: <FormGroup>this.insuranceForm, id: INSURANCE });
      }
    });

    if (this.insuranceValues.length === 1) {
      this.insuranceForm.controls.insuranceSelect.setValue(this.insuranceValues[0].id);
    }

    if (this.mode === REQUEST_MODE_VIEW) {
      if (this.state.id !== PENDIENTES_DE_DATOS) {
        this.insuranceForm.disable();
      }
      this.insuranceForm.controls.insuranceSelect.setValue(this.insurance);
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.insuranceForm.controls.insuranceSelect.setValue(this.insurance);
    }
    this.isFinishedLoading.emit({ formID: INSURANCE, value: true });
  }

  private createForm() {
    this.insuranceForm = this.formBuilder.group({
      insuranceSelect: ['N', Validators.required],
    });
    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.insuranceForm, INSURANCE);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.insuranceForm, INSURANCE);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.insuranceForm, INSURANCE);
    }
  }
}
